export default {
  twoFactorMethodsList: [],
  mfaSettings: {},
  status: {}
};